class PrintFamilyRail {
  constructor() {
    this.rails = document.querySelectorAll('[data-print-family-suggest]');
    this.suggestURL = window.routes.predictive_search_url || '/search/suggest';

    if (!this.rails.length) return;

    this.init();
  }

  init() {
    this.rails.forEach((rail) => {
      const term = rail.dataset.term;
      const limit = rail.dataset.limit || 4;
      if (!term) return;

      this.fetchSuggest(rail, term, limit);
    });
  }

  fetchSuggest(rail, term, limit) {
    const url = `${this.suggestURL}?q=${encodeURIComponent(term)}&${encodeURIComponent('resources[limit]')}=${limit}&section_id=print-family-suggest`;

    fetch(url)
      .then((response) => {
        if (!response.ok) return;
        return response.text();
      })
      .then((text) => {
        if (!text) return;
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const markup = doc.querySelector('#shopify-section-print-family-suggest');
        if (!markup || !markup.innerHTML.trim()) {
          rail.remove();
          return;
        }
        rail.innerHTML = markup.innerHTML;
      })
      .catch((error) => {
        rail.remove();
      });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new PrintFamilyRail();
});